import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Teleport as _Teleport, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_template_tabs = _resolveComponent("template-tabs")!
  const _component_image_actions = _resolveComponent("image-actions")!
  const _component_tree_panel = _resolveComponent("tree-panel")!
  const _component_images_panel = _resolveComponent("images-panel")!
  const _component_template_actions = _resolveComponent("template-actions")!
  const _component_templates_panel = _resolveComponent("templates-panel")!
  const _component_template_slug_modal = _resolveComponent("template-slug-modal")!
  const _component_default_layout = _resolveComponent("default-layout")!

  return (_openBlock(), _createBlock(_component_default_layout, {
    class: "templates",
    "header-subtitle": _ctx.$t('index_templates.subtitle')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_template_tabs, {
        class: "template-tabs uk-container",
        "active-tab": _ctx.currentKind!,
        onTabClicked: _ctx.tabClickHandler
      }, null, 8, ["active-tab", "onTabClicked"]),
      (_ctx.isImageKind)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_image_actions, {
              class: "uk-container",
              "tree-view": _ctx.itemTreeView,
              onItemTreeSwitcherToggled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTreeView())),
              onImageUploaded: _ctx.imageUploadedHandler
            }, null, 8, ["tree-view", "onImageUploaded"]),
            (_ctx.itemTreeView)
              ? (_openBlock(), _createBlock(_component_tree_panel, {
                  key: 0,
                  class: "uk-margin-medium-bottom",
                  type: _ctx.currentKind!,
                  loading: _ctx.itemTreeLoading,
                  onPaginate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadEditorVariables({ kind: _ctx.currentKind! })))
                }, null, 8, ["type", "loading"]))
              : (_openBlock(), _createBlock(_component_images_panel, {
                  key: 1,
                  class: "uk-margin-medium-bottom",
                  onPaginate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadImages())),
                  onDeleteImage: _ctx.deleteImageHandler
                }, null, 8, ["onDeleteImage"]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_template_actions, {
              class: "uk-container",
              kind: _ctx.currentKind ?? '',
              "tree-view": _ctx.itemTreeView,
              onCreateNewTemplate: _ctx.createNewTemplateHandler,
              onItemTreeSwitcherToggled: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTreeView()))
            }, null, 8, ["kind", "tree-view", "onCreateNewTemplate"]),
            (_ctx.itemTreeView)
              ? (_openBlock(), _createBlock(_component_tree_panel, {
                  key: 0,
                  class: "uk-margin-medium-bottom",
                  type: _ctx.currentKind!,
                  loading: _ctx.itemTreeLoading,
                  onPaginate: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadEditorVariables({ kind: _ctx.currentKind! })))
                }, null, 8, ["type", "loading"]))
              : (_openBlock(), _createBlock(_component_templates_panel, {
                  key: 1,
                  class: "uk-margin-medium-bottom",
                  onPaginate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadTemplates()))
                }))
          ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_component_template_slug_modal, {
          submittable: _ctx.canWrite,
          onSubmit: _ctx.submitNewTemplateSlugHandler
        }, null, 8, ["submittable", "onSubmit"])
      ]))
    ]),
    _: 1
  }, 8, ["header-subtitle"]))
}